import React from "react";
import { Typography } from "@mui/material";
import TopSection from "../../Components/Common/Top/TopSection";
import BottlerOnBoarding from "./BottlerOnBoarding";

const OnboardBottler = () => {
  return (
    <>
      <TopSection
        labelList={[
          { title: "Home", path: "/dashboard" },
          { title: "History" },
        ]}
        title="Bottler Onboarding"
      />
       <div className="container">
        <BottlerOnBoarding/>
      </div>
    </>
  );
};

export default OnboardBottler;
